import ApiService from '@/services/api.service';

const PatientPortalSetupService = {
    getAll(parameters) {
        const requestData = {
            method: 'get',
            url: '/PatientPortalSetups/',
            headers: {},
            params: parameters
        };
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/PatientPortalSetups/${id}`);
    },

    add(data) {
        return ApiService.post(`/PatientPortalSetups`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientPortalSetups/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientPortalSetups/${id}`, data);
    },

    getAllInfo() {
        return ApiService.get(`/PatientPortalSetups/Info`);
    },

    addOrUpdate(data) {
        return ApiService.post(`/PatientPortalSetups/InsertOrUpdate`, data);
    }
};

export default PatientPortalSetupService;
